import baseApi from 'shared/api/baseApi';

export interface AdminRoleRow {
  id: number;
  name: string;
  displayName: string;
}

interface GetRolesResponse {
  success?: boolean;
  roles: AdminRoleRow[];
}

const adminRolesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getAdminRoles: build.query<AdminRoleRow[], { includeInactive?: boolean } | null>({
      query: (params) => ({
        url: '/admin/roles',
        params: params ?? undefined,
      }),
      transformResponse: (response: GetRolesResponse | AdminRoleRow[]): AdminRoleRow[] => {
        if (Array.isArray(response)) {
          return response;
        }
        return response.roles ?? [];
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetAdminRolesQuery } = adminRolesApi;
